import React, { useEffect, useState } from "react";
import MediaQuery from "react-responsive";
import { Row, Input, Col } from "antd";
import {
  DownOutlined,
  SearchOutlined,
  UserAddOutlined,
  UserOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "./Viewers.css";
import FollowerViewItem from "../../../components/FollowerViewItem/FollowerViewItem";
import { getViews } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../routes/history";
import Loader from "../../../components/Loading/Loader";

export default function Views() {
  const dispatch = useDispatch();
  const [windowDimensions, setWindowDimensions] = useState(window.innerWidth);

  const [profilePictureUrl, setprofilePictureUrl] = useState("");

  const views = useSelector((state) => state.viewIncrementReducer.response);
  const loading = useSelector((state) => state.viewIncrementReducer.loading);
  const error = useSelector((state) => state.viewIncrementReducer.error);

  useEffect(() => {
    setWindowDimensions(window.innerWidth);
  }, [window.innerWidth]);
  console.log(views?.viewerProfile, "NIGGA");

  // useEffect(() => {
  //   dispatch(getViews());
  // }, []);

  const originalArray = views?.viewerProfile;

  const viewsMap = {};

  originalArray?.forEach((item) => {
    const {
      _id,
      UserName,
      firstName,
      lastName,
      locationWithCountry,
      pictureURL,
    } = item;
    const viewKey = `${_id}`;

    if (viewsMap[viewKey]) {
      viewsMap[viewKey].count++;
    } else {
      viewsMap[viewKey] = {
        profile: {
          _id,
          UserName,
          firstName,
          lastName,
          locationWithCountry,
          pictureURL,
        },
        count: 1,
      };
    }
  });

  const filteredArray = Object.values(viewsMap);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          height: "400px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader style={{ margin: "auto" }} />
      </div>
    );
  } else {
    if (views?.viewerProfile?.length !== 0) {
      return (
        <React.Fragment>
          <main className="followers_main">
            {windowDimensions < 768 ? (
              <div>
                <ArrowLeftOutlined
                  className="backarrow_views"
                  onClick={() => history.goBack()}
                />
              </div>
            ) : null}
            <div className="followersTitle">Views</div>
            <p className="itemsLength">{filteredArray?.length} items</p>
            <Row>
              {filteredArray && filteredArray?.length ? filteredArray?.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                    <FollowerViewItem
                      // name={item.viewer_profile_info[0]?.UserName}
                      name={
                        item?.profile?.firstName
                          ? item?.profile?.firstName +
                            " " +
                            item?.profile?.lastName
                          : item?.profile?.UserName
                      }
                      // location={item.viewer_profile_info[0]?.Profiles?.LocationWithCountry != null ? item.viewer_profile_info[0]?.Profiles?.LocationWithCountry : item.viewer_profile_info[0]?.Profiles?.Countries.CountryName}
                      location={
                        item?.profile?.locationWithCountry != null
                          ? item?.profile?.locationWithCountry
                          : item?.profile?.city && item?.profile?.region
                          ? item?.profile?.city + ", " + item?.profile?.region
                          : null
                      }
                      // views={item.views}
                      // Key={item.viewer_profile_info[0]?.Profiles?.PictureUrl}
                      Key={item?.profile?.pictureURL}
                      views={item?.count}
                    />
                  </Col>
                );
              })
              : <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center'}}>No data found</div>
              }
            </Row>
          </main>
        </React.Fragment>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            height: "400px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>No Views</p>
        </div>
      );
    }
  }
}
